import { render, staticRenderFns } from "./CategoryMenuCreateOrEdit.vue?vue&type=template&id=58613938&"
import script from "./CategoryMenuCreateOrEdit.vue?vue&type=script&lang=js&"
export * from "./CategoryMenuCreateOrEdit.vue?vue&type=script&lang=js&"
import style0 from "./CategoryMenuCreateOrEdit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports